
import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="w-full px-4 py-3 md:py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center gap-2">
            <div className="w-9 h-9 md:w-10 md:h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center">
              <i className="ri-funnel-fill text-white text-lg md:text-xl"></i>
            </div>
            <span className="text-lg md:text-xl font-bold">
              <span className="text-teal-600">AI FU</span>
              <span className="text-gray-900">nnel</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center justify-center gap-6 flex-1 mx-8">
            <a href="/" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap">
              홈
            </a>
            <a href="/funnel-generator" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap">
              퍼널 생성
            </a>
            <a href="/my-funnels" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap">
              내 퍼널
            </a>
            <a href="/funnel-analytics" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap">
              분석
            </a>
            {profile?.role === 'admin' && (
              <a href="/admin" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap">
                관리자
              </a>
            )}
          </nav>

          <div className="flex items-center gap-3">
            {user ? (
              <>
                <a
                  href="/profile"
                  className="hidden lg:flex items-center gap-2 px-4 py-2 text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap"
                >
                  <i className="ri-user-line"></i>
                  내 정보
                </a>
                <div className="hidden md:flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg">
                  <i className="ri-user-fill text-teal-600"></i>
                  <span className="text-sm font-medium text-gray-700">{profile?.full_name || user.email}</span>
                </div>
                <button
                  onClick={handleSignOut}
                  className="hidden lg:block px-4 py-2 text-gray-700 hover:text-red-600 transition-colors font-medium whitespace-nowrap"
                >
                  로그아웃
                </button>
              </>
            ) : (
              <>
                <a
                  href="/login"
                  className="hidden lg:block px-4 py-2 text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap"
                >
                  로그인
                </a>
                <a
                  href="/signup"
                  className="hidden lg:block px-6 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-lg font-medium transition-colors whitespace-nowrap"
                >
                  회원가입
                </a>
              </>
            )}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden p-2 text-gray-700 hover:text-teal-600"
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* 모바일 메뉴 */}
        {isMenuOpen && (
          <div className="lg:hidden mt-4 py-4 border-t border-gray-200">
            <nav className="flex flex-col gap-3">
              <a href="/" className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors font-medium text-center whitespace-nowrap">
                홈
              </a>
              <a href="/funnel-generator" className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors font-medium text-center whitespace-nowrap">
                퍼널 생성
              </a>
              <a href="/my-funnels" className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors font-medium text-center whitespace-nowrap">
                내 퍼널
              </a>
              <a href="/funnel-analytics" className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors font-medium text-center whitespace-nowrap">
                분석
              </a>
              {user && (
                <a href="/profile" className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors font-medium text-center whitespace-nowrap">
                  <i className="ri-user-line mr-2"></i>
                  내 정보
                </a>
              )}
              {profile?.role === 'admin' && (
                <a href="/admin" className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors font-medium text-center whitespace-nowrap">
                  관리자
                </a>
              )}
              {user ? (
                <button
                  onClick={handleSignOut}
                  className="px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors font-medium text-center whitespace-nowrap"
                >
                  로그아웃
                </button>
              ) : (
                <>
                  <a
                    href="/login"
                    className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors font-medium text-center whitespace-nowrap"
                  >
                    로그인
                  </a>
                  <a
                    href="/signup"
                    className="px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-lg font-medium transition-colors text-center whitespace-nowrap"
                  >
                    회원가입
                  </a>
                </>
              )}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
